import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            <div className="flex-shrink-0 w-[240px] md:w-[280px]">
              <div className="rounded-3xl overflow-hidden">
                <img
                  src={appData.image}
                  alt="每日大赛APP界面展示"
                  className="w-full h-auto object-cover"
                  loading="lazy"
                />
              </div>
            </div>

            <div className="flex-1 text-center lg:text-left">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100/80 text-accent-700 text-xs font-semibold mb-4">
                随时随地
              </span>
              <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
                {appData.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6 max-w-[560px] mx-auto lg:mx-0">
                {appData.description}
              </p>

              <div className="grid grid-cols-2 gap-3 mb-8 max-w-[480px] mx-auto lg:mx-0">
                {appData.features.map((feat, i) => (
                  <div key={i} className="flex items-center gap-2 px-3 py-2 rounded-lg bg-background-100">
                    <i className="ri-checkbox-circle-fill text-accent-500 text-sm"></i>
                    <span className="text-xs md:text-sm text-foreground-700 font-medium">{feat}</span>
                  </div>
                ))}
              </div>

              <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-apple-fill"></i>
                  App Store
                </a>
                <a
                  href="#app"
                  className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  <i className="ri-android-fill"></i>
                  安卓下载
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}